<template>
  <div v-loading="isBusy">
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        element-loading-spinner="el-icon-loading"
        label-width="170px"
    >
      <el-form-item label="Name" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>

      <el-form-item label="Slug" prop="slug">
        <el-select v-model="form.slug" class="w-100">
          <el-option
              v-for="option in slugOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Authority" prop="authority">
        <el-input v-model="form.authority"></el-input>
      </el-form-item>
    </el-form>
    <button class="btn btn-purple px-4" @click="store">Store</button>
  </div>
</template>

<script>
import BaseForm from '../form';

export default {
  extends: BaseForm,

  props: {
    slugOptions: Array,
  },

  data() {
    const form = {
      name: null,
      slug: null,
      authority: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
    }
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm(model) {
      this.form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
    },
  },
}
</script>
